import superviseBillApi from '@/api/park/superviseBill';
export default {
  methods: {
    // 按钮点击
    chooseClick(type) {
      this[type]();
    },
    // 审批处理函数
    approvalHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      this.selectData = this.selectionList[0];
      if (this.selectData.billStatus == '04') {
        this.$refs.freezeTipDialog.openDialog();
      } else if (this.selectData.billStatus == '10') {
        const path = {
          path: '/park/superviseBill',
          name: 'billApproval',
          meta: {
            keepAlive: true,
            title: '监管单审批',
          },
          query: {
            status: 'approval',
            id: this.selectionList[0].id,
          },
        };
        this.$router.push(path);
      } else {
        this.$message.error('该监管单状态不支持审批！');
      }
    },
    // 选择一行判断
    checkSelectOneData() {
      if (!this.selectionList.length) {
        this.$message.error('请选择一行操作');
        return false;
      }
      if (this.selectionList.length != 1) {
        this.$message.error('只能选择一行操作');
        return false;
      }
      return true;
    },
    // 导出 处理函数
    async exportHandler() {
      const idList = this.selectionList.map((item) => item.id);
      const tableList = this.tableData.map((item) => item.id);
      let data;
      if (!idList.length && !tableList) {
        this.$message.error('没有数据可以导出！');
        return;
      }
      if (!idList.length) {
        this.isLoading = true;
        data = await this.$axios.post(superviseBillApi.BILL_EXPORT, { ids: tableList });
        this.isLoading = false;
      }
      this.isLoading = true;
      data = await this.$axios.post(superviseBillApi.BILL_EXPORT, { ids: idList });
      this.isLoading = false;
      if (data.data.code === 0) {
        window.location.href = data.data.data;
        this.$message.success('导出成功');
      } else {
        this.$message.error('导出失败');
      }
    },
    // 手动冻结 处理函数
    freezeHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      this.selectData = this.selectionList[0];
      if (this.selectData.billStatus == '04') {
        this.$refs.freezeTipDialog.openDialog();
      } else if (this.selectData.billStatus == '03') {
        this.$refs.freezeDialogRef.openDialog();
      } else {
        this.$message.error('选择行不能执行冻结操作');
      }
    },
    // 解冻申请 处理函数
    applicationUnfreezingHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      this.selectData = this.selectionList[0];
      if (this.selectData.billStatus == '04') {
        this.$refs.applicationUnfreezingDialogRef.openDialog();
      } else {
        this.$message.error('选择行不能执行解冻操作');
      }
    },
    // 解押申请
    dischargeApplicationHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      this.selectData = this.selectionList[0];
      if (this.selectData.billStatus == '04') {
        this.$refs.freezeTipDialog.openDialog();
      } else if (this.selectData.billStatus == '06') {
        this.$refs.dischargeApplicationDialogRef.openDialog();
      } else {
        this.$message.error('选择行不能执行解押操作');
      }
    },
    setSearchParams() {
      const { pageSize, pageNum } = this.$refs.siruiTable.page;
      let params = { ...this.query, pageSize, pageNum };
      params.registerCreatePersonNo = params.registerCreatePersonNo
        ? params.registerCreatePersonNo[0].id
        : null;
      params.payerCode = params.payerCode ? params.payerCode[0].partnerCode : null;
      return params;
    },
  },
};
